import CACA1060RequestModel from '@/api/data/CAC/CACA1060/CACA1060RequestModel'
import CACA1060ResponseModel from '@/api/data/CAC/CACA1060/CACA1060ResponseModel'

import RestService from '@/common/RestService'
import ApiUrlConstants from '@/common/ApiUrlConstants'

export default class CACG1060Service {
  /**
   *
   * @param productNo
   * @param shhnCd
   * @returns caca1060ResponseModel
   */
  public async callAPICACA1060(
    productNo,
    shhnCd
  ): Promise<CACA1060ResponseModel> {
    const caca1060RequestModel = new CACA1060RequestModel()
    caca1060RequestModel.productNo = productNo
    caca1060RequestModel.shhnCd = shhnCd
    const caca1060ResponseModel: CACA1060ResponseModel = <
      CACA1060ResponseModel
    > await RestService.post(ApiUrlConstants.CACA1060, caca1060RequestModel)
    return caca1060ResponseModel
  }
}
